import { put, select, takeEvery } from 'redux-saga/effects'
import { DELETE_FUNCTION } from 'actions/feature/functions'
import { deleteNotes } from 'actions/feature/notes'

export function* watchUpdateSelectedInput() {
  yield takeEvery(DELETE_FUNCTION, deleteFunctionNote)
}

function* deleteFunctionNote({ payload }) {
  const { functionId } = payload

  const functionNotes = yield select((state) =>
    state
      .getIn(['feature', 'notes'])
      .filter((note) => note.get('subUri') === functionId)
      .toJS()
  )

  const noteIds = functionNotes.map((note) => note.id)

  yield put(deleteNotes(noteIds))
}
